import { render, staticRenderFns } from "./FamilyOrder.vue?vue&type=template&id=9febfe0a&scoped=true"
import script from "./FamilyOrder.vue?vue&type=script&lang=js"
export * from "./FamilyOrder.vue?vue&type=script&lang=js"
import style0 from "./FamilyOrder.vue?vue&type=style&index=0&id=9febfe0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9febfe0a",
  null
  
)

export default component.exports